import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconScript: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase
      {...props}
      ariaLabel="script, paper, page, contract, file, document"
    >
      <path
        d="M7 15.5001C7 15.5001 7 8.27553 7 5.99689C7 5.46697 7.21052 4.95894 7.58617 4.58455C7.96104 4.21015 8.46974 4.00049 9.00035 4.00049C12.1715 4.00049 18 4.00049 18 4.00049"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M13.9974 20L6.0329 20C5.49368 20 4.97658 19.7859 4.59526 19.4047C4.21395 19.0235 4 18.5063 4 17.9675V17.9675C4 16.8809 4.88156 16 5.9682 16C7.75398 16 9.21745 16 10.9994 16C12.1039 16 13 16.8974 13 18.002V18.002C13 19.105 13.895 20 14.998 20H15.002C16.105 20 17 19.105 17 18.002V9"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 4C19.5304 4 20.0393 4.21077 20.4143 4.58585C20.7892 4.96092 21 5.46954 21 6C21 6.32937 21 6.6708 21 7.00015C21 8.10472 20.1046 9 19 9H17V6C17 5.46954 17.2108 4.96092 17.5857 4.58585C17.9607 4.21077 18.4696 4 19 4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 8H13"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 12H12"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </CentralIconBase>
  );
};

export default IconScript;
